// extracted by mini-css-extract-plugin
export var layoutContainer = "_bq-0";
export var layoutContainerNoRounding = "_bq-6";
export var layoutContainerOpen = "_bq-5";
export var layoutContainerResizing = "_bq-1";
export var mainContent = "_bq-2";
export var resizeDivider = "_bq-3";
export var slidePanel = "_bq-4";